<template>
  <v-container fluid class="pa-0">
    <v-content style="margin: 12xp; padding: 0;">
      <slc-help-menu :is-mobile="true" :links-config="linksConfig" />
    </v-content>
  </v-container>
</template>

<script>
import SlcHelpMenu from "@/components/SlcHelpDropDown/SlcHelpMenu.vue";
import useHelpLinks from "@/components/SlcHelpDropDown/useHelpLinks";

export default {
  components: { SlcHelpMenu },
  computed: {
    linksConfig() {
      const { $store } = this;
      return useHelpLinks({ $store });
    }
  }
};
</script>
